//项目定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 项目类型
 */
class Type extends UltMeta {
    BUY = new Meta(1, "采购项目");
    SELL = new Meta(2, "销售项目");
}

export const TYPE = new Type();

/**
 * 项目状态
 */
class ProjectState extends UltMeta {
    PENDING = new Meta(1, "合同待签约");
    PROCESSING = new Meta(2, "履约中");
    FINISHED = new Meta(3, "已结清");
}

export const PROJECT_STATE = new ProjectState();

/**
 * 项目状态
 */
class ProjectStateBank extends UltMeta {
    PROCESSING = new Meta(2, "履约中");
    FINISHED = new Meta(3, "收款完成");
}

export const PROJECT_STATE_BANK = new ProjectStateBank();

/**
 * 保存方式
 */
class ProjectSubmitType extends UltMeta {
    SAVE_AS_DRAFT = new Meta(1, "保存为草稿");
    SAVE_AND_SUBMIT = new Meta(2, "保存并提交");
}

export const PROJECT_SUBMIT_TYPE = new ProjectSubmitType();

/**
 * 服务费结算状态
 */
class ServiceCostState extends UltMeta {
    UNSETTLED = new Meta(1, "未结算");
    SETTLED = new Meta(2, "已结算");
    AUTO_SETTLED = new Meta(3, "自动结算");
}

export const SERVICE_COST_STATE = new ServiceCostState();

/**
 * 用户PC项目详情tab
 */
class ProjectPCTabItems extends UltMeta {
    PROJECT_INFO = new Meta(1, "项目信息");
    CONTRACT_INFO = new Meta(2, "合同信息", "ContractInfo");
    PAYMENT_INFO = new Meta(3, "付款明细", "PaymentInfo");
    ORDER_INFO = new Meta(4, "订单明细", "OrderDetail");
    DELIVERY_INFO = new Meta(5, "提货明细", "DeliveryInfo");
    SIGN_INFO = new Meta(6, "签收明细", "ReceiptInfo");
    RECONCILIATION_INFO = new Meta(7, "结算明细", "ReconciliationInfo");
    BILLING_INFO = new Meta(8, "开票明细", "InvoiceInfo");
}

export const PROJECT_PC_TAB_ITEMS = new ProjectPCTabItems();

class ProjectTabItems extends UltMeta {
    PROJECT_INFO = new Meta(1, "项目概况");
    CONTRACT_INFO = new Meta(2, "合同信息", "ContractInfo");
    PURCHASE_INFO = new Meta(3, "采购信息", "PaymentInfo");
    SALES_INFO = new Meta(4, "销售信息", "DeliveryInfo");
    STORAGE_INFO = new Meta(5, "仓储信息", "StorageInfo");
    PROJECT_ANALYSIS = new Meta(6, "项目分析", "ProjectAnalysis");
    // RECONCILIATION_INFO = new Meta(6, "结算明细", "ReconciliationInfo");
    // BILLING_INFO = new Meta(7, "开票明细", "InvoiceInfo");
}

export const PROJECT_TAB_ITEMS = new ProjectTabItems();

class StockProjectTabItems extends UltMeta {
    PROJECT_INFO = new Meta(1, "项目概况");
    CONTRACT_INFO = new Meta(2, "合同信息", "ContractInfo");
    STORAGE_INFO = new Meta(5, "仓储信息", "StorageInfo");
    PROJECT_ANALYSIS = new Meta(6, "项目分析", "ProjectAnalysis");
}

export const STOCK_PROJECT_TAB_ITEMS = new StockProjectTabItems();

class ProjectSaleTabItems extends UltMeta {
    PROJECT_INFO = new Meta(1, "项目信息");
    CONTRACT_INFO = new Meta(2, "合同信息", "ContractInfo");
    PAYMENT_INFO = new Meta(3, "收款明细", "PaymentInfo");
    DELIVERY_INFO = new Meta(4, "订单明细", "DeliveryInfo");
    DELIVER_TAB = new Meta(5, "发货明细", "DeliverTab");
    SIGN_INFO = new Meta(6, "签收明细", "ReceiptInfo");
    RECONCILIATION_INFO = new Meta(7, "结算明细", "ReconciliationInfo");
    BILLING_INFO = new Meta(8, "开票明细", "InvoiceInfo");
}

export const PROJECT_SALE_TAB_ITEMS = new ProjectSaleTabItems();

// dashboard中销售项目利润排行-项目状态

class DashboardProjectState extends UltMeta {
    PROCESSING = new Meta(2, "履约中");
    FINISHED = new Meta(3, "已结清");
}

export const DASHBOARD_PROJECT_STATE = new DashboardProjectState();

// 出库条件
class OutBoundConditions extends UltMeta {
    FULL_PAYMENT = new Meta(1, "全款结算");
    PARTIAL_PAYMENT = new Meta(2, "部分付款");
    PLEDGE = new Meta(3, "货物质押");
}

export const OUT_BOUND_CONDITIONS = new OutBoundConditions();

// 控货比要求

class ControlRatioWay extends UltMeta {
    COUNT = new Meta(1, "按数量/重量");
    AMOUNT = new Meta(2, "按金额");
}

export const CONTROL_RATIO_TYPE = new ControlRatioWay();

// 项目-可预估提货余额表单 -加减方向
class EstimatedDirection extends UltMeta {
    ADD = new Meta(1, "加");
    SUBTRACT = new Meta(2, "减");
}

export const ESTIMATED_DIRECTION = new EstimatedDirection();

// 项目-可预估提货余额表单 =增减项
class EstimatedItem extends UltMeta {
    PAYMENT = new Meta(1, "货款");
    ORDER_AMOUNT = new Meta(2, "订单金额");
    REC_AMOUNT = new Meta(3, "结算金额");
    ORDER_DEPOSIT = new Meta(4, "订单保证金");
    DEPOSIT = new Meta(5, "履约保证金");
    FROZEN_AMOUNT = new Meta(6, "冻结金额");
    PLEDGE_GOODS = new Meta(7, "抵质押物");
    DEFINITION = new Meta(8, "自定义");
}

export const ESTIMATED_ITEM = new EstimatedItem();

// 录入企业参数
class RecordedParam extends UltMeta {
    UP = new Meta(1, "上游为录入企业");
    DOWN = new Meta(2, "下游为录入企业");
}

export const RECORDED_PARAM = new RecordedParam();

/**
 * 账期计算方式
 */
class SettlePeriodWay extends UltMeta {
    MONTH = new Meta(1, "按月");
    DAY = new Meta(2, "按天");
}

export const SETTLE_PERIOD_WAY = new SettlePeriodWay();

// ============= 监管项目 =============

/**
 * 委托方类型: 往来企业， 关联企业
 */

class EntrustType extends UltMeta {
    DEALINGS_ENTERPRISE = new Meta(1, "往来企业");
    MAIN_BODY = new Meta(2, "关联企业");
}

export const ENTRUST_TYPE = new EntrustType();

/**
 * 仓储管理-项目管理
 */

class StoreProjectTabItems extends UltMeta {
    PROJECT_INFO = new Meta(1, "项目概况");
    CONTRACT_INFO = new Meta(2, "合同信息", "ContractInfo");
    STORAGE_INFO = new Meta(5, "仓储信息", "StorageInfo");
}

export const STORE_PROJECT_TAB_ITEMS = new StoreProjectTabItems();

// 往来企业主体类型下拉选项
class QueryBodyType extends UltMeta {
    CUSTOMER = new Meta(1, "客户");
    SUPPLIER_CHAIN = new Meta(2, "供应链");
    ALL = new Meta(3, "客户和供应链");
}

export const QUERY_BODY_TYPE = new QueryBodyType();
